export default __webpack_public_path__ + "static/media/Saibaba8.e6db9525.jpg";